import { createEventFactory, createName } from '@cp/shared/tracking';

export const DialogEvents = {
  DialogSelect: createEventFactory({
    name: createName('dialog', 'select'),
    goalId: 'vybor_soobshcheniya_v_bloke_soobshchenij_listinga',
    goalName: 'vybor_soobshcheniya_v_bloke_soobshchenij_listinga',
  }),
  DialogListViewAll: createEventFactory({
    name: createName('dialog', 'showAll', 'click'),
    goalId: 'nazhatie_na_knopku_pokazat_vse_v_bloke_soobshchenij_listinga',
    goalName: 'Нажатие на кнопку "Показать все" в блоке сообщений листинга',
  }),
  MessageSend: createEventFactory({
    name: createName('dialog', 'messge', 'send'),
    goalId: 'otpravka_soobshcheniya',
    goalName: 'Отправка сообщения',
  }),
} as const;
